export default __webpack_public_path__ + "static/media/cart.14617141.jpeg";